var _Path, _Path2, _Path3, _Path4, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgEmptyFamily = function SvgEmptyFamily(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/React.createElement(G, {
    fill: props.fillLine,
    clipPath: "url(#empty_family_svg__a)"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M45.05 43.397h.009a11.26 11.26 0 0 1 9.354 5 .446.446 0 0 0 .767 0 11.27 11.27 0 0 1 10.731-4.91 9.53 9.53 0 0 1 7.7 5.927c.684 1.649.938 3.445.736 5.219a10.24 10.24 0 0 1-2.106 5.139L54.796 82.114 37.119 59.467a9.9 9.9 0 0 1-2.086-5.248 10.08 10.08 0 0 1 4.441-9.192 9.9 9.9 0 0 1 5.4-1.628zm9.746 34.676L70.277 58.24a7.76 7.76 0 0 0 1.6-3.892 8 8 0 0 0-.562-3.982 7.4 7.4 0 0 0-2.185-2.947 6.84 6.84 0 0 0-3.516-1.465 8.78 8.78 0 0 0-8.367 3.83 2.93 2.93 0 0 1-4.894 0 8.78 8.78 0 0 0-7.282-3.9h-.166a7.4 7.4 0 0 0-4.054 1.214 7.59 7.59 0 0 0-3.337 6.907c.13 1.435.675 2.8 1.568 3.93z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M9.946 24.748h89.516v74.6H9.946zm87.03 2.487H12.432v69.623h84.543z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M19.892 34.694h69.623v54.7H19.892zm67.137 2.486H22.378v49.732h64.65zM61.14 27.334 49.73 15.358 38.323 27.334l-1.8-1.715 13.208-13.861L62.94 25.619z"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M49.731 2.487a4.292 4.292 0 1 0 4.292 4.292 4.3 4.3 0 0 0-4.292-4.292m0-2.487a6.78 6.78 0 1 1 0 13.558 6.78 6.78 0 0 1 0-13.558M0 24.748h12.433v74.6H0zm9.943 2.486H2.486v69.624h7.457z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "empty_family_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h99.462v99.344H0z"
  })))));
};
export default SvgEmptyFamily;